














import { Vue, Component, Prop } from 'vue-property-decorator'
import store from 'src/assets/store'
import confirm from 'components/modals/Confirm'
import api from 'src/assets/api/gql'
import ItemUpdate from 'src/graphql/item/ItemUpdate.gql'
import { Item } from 'src/graphql/types'

@Component
export default class PresenterLayoutMenuButtonDelete extends Vue {

  get item () {
    return store.state.presenter.item!
  }

  async action () {
    await confirm({
      title: this.$t('label.deleteConfirm').toString(),
      message: this.item.name,
      btnRight: this.$t('label.delete').toString(),
      btnRightColor: 'warning'
    })
    await api.mutate({
      query: ItemUpdate,
      variables: {
        id: this.item.id,
        data: { deletedAt: (new Date()).toJSON() }
      }
    })
    this.redirectToParent()
  }

  redirectToParent () {
    const parentPathLength = this.item.path.lastIndexOf('.')
    if (parentPathLength > 0) {
      const parentPath = this.item.path.substr(0, parentPathLength)
      const parentId = parentPath.substr(parentPath.lastIndexOf('.') + 1)
      this.$router.replace('/presenter/' + parentId)
    } else {
      this.$router.replace('/presenter')
    }
  }
}
